<!-- EBL Confirmation Pop Up -->
<div *ngIf="modalToOpen==='ebl_confirmation'">
    <div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">{{'shipment.edit' | cxTranslate}}</h4>
        <i class="fa fa-times close-icon" aria-hidden="true" (click)="closeModal()"></i>
		
	</div>
	<div class="modal-body">
        <h6 class="text-black fw-bold">{{'shipment.ebl' | cxTranslate}}</h6>
        <form>
            <div class="row d-flex flex-row ">
                <div class="form-check pl-5">
                    
                    <label class="form-check-label" for="elbyes">
                        <input class="form-check-input" type="radio" name="ebl_confirmation" id="eblyes" value="yes" [formControl]="ebl_confirmation" (change)="updateEBL('yes')">
                      {{'shipment.yes' | cxTranslate}}
                    </label>
                  </div>
                  <div class="form-check pl-5">
                   
                    <label class="form-check-label" for="eblno">
                        <input class="form-check-input" type="radio" name="ebl_confirmation" id="eblno" value="no" [formControl]="ebl_confirmation" (change)="updateEBL('no')">{{'shipment.no' | cxTranslate}}
                    </label>
                  </div>
            </div>
           
        </form>
    </div>
    <div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="SaveEBL()">{{'shipment.save' | cxTranslate}}</button>
        <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">{{'shipment.cancel' | cxTranslate}}</button>
	</div>
</div>

<!--batch completed delivery tracking popup-->
<div *ngIf="modalToOpen==='batchCompleted'">
  <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ 'shipment.batchCompletedHeader' | cxTranslate }}</h4>
      <i class="fa fa-times close-icon" aria-hidden="true" (click)="closeBatchModal()"></i>
  </div>
  <div class="modal-body">
    <h6 class="text-black ">{{ 'shipment.batchCompletedMsg' | cxTranslate }}</h6>
    <div class="card">
      <div class="mb-3 mt-3 col-md-12 col-sm-12">
        <div>
          <div class="dropdiv" (dragover)="onDragOver($event)" (drop)="onDropSuccess($event)">
            <div class="row d-flex align-items-center">
              <div class="col-md-1">
                <img src="/images/feather_upload-cloud.svg" class="pr-1" alt="icon" width="48"
                  height="48">
              </div>
              <div class="col-md-6 ">
                <div class="small">{{ 'batches.selectAFile' | cxTranslate }}</div>
                <div class="small">{{ 'batches.fileNoMoreThan10mb' | cxTranslate }}</div>
              </div>
              <div class="col-md-5 text-right">
                <span class="d-none">
                  <input accept="application/pdf, image/jpg, image/jpeg, image/png" type="file" #fileInput ng2FileSelect
                    [uploader]="uploader" (onFileSelected)="onFileSelected($event)" />
                </span>
                <div class="btn-group" (click)="fileInput.click()">
                  <label for="files" class="btn btn-outline-primary p-2">{{  'batches.selectFile' | cxTranslate }}</label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div *ngIf="uploader.queue.length != 0">
      <div class="fw-600 mb-2 mt-2"> {{'batches.fileAdded' | cxTranslate}}</div>
    </div>
    <div *ngFor="let item of shipData.documents let i = index;">
      <div (mouseenter)="hoverFileShow1(i)" (mouseleave)="hoverFileHide1(i)" class="small file d-flex">
        <div class="col-md-12">
          <img src="/icons/Vectorpdf.svg" class="pr-1" alt="icon" width="21" height="21"><span>{{
            item?.documentName }}</span><span>.</span>
          <a class="btn btn-sm text-primary shadow-none small" href="{{item.downloadURL}}" target="_blank">
            {{'batches.preview' | cxTranslate}}</a>
          <span class="float-right mt-3 fs-10">{{
            item?.size / 1024 / 1024 | number: '.3'}} MB</span>
        </div>
        <div *ngIf="isHidden" class="float-right row" (click)="deleteFile(i)">
          <span id="hover{{i}}" class="close-icon position-absolute text-center pe-auto"
            aria-hidden="true">&times;</span>
        </div>
      </div>

    </div>
    <div *ngFor="let item of fileArray; let i = index;">
      <div (mouseenter)="hoverFileShow(i)" (mouseleave)="hoverFileHide(i)" class="small file d-flex">
        <div class="col-md-12">
          <img src="/icons/Vectorpdf.svg" class="pr-1" alt="icon" width="21" height="21"><span>{{
            item?.name }}</span><span>.</span><a class="btn btn-sm text-primary small"> {{'batches.preview' | cxTranslate}}</a> <span
            class="float-right mt-3 fs-10">{{
            item?.size / 1024 / 1024 | number: '.3' }} MB</span>
        </div>
        <div *ngIf="selected" class="float-right row" (click)="removeFile(i)">
          <span id="remove{{i}}" class="close-icon position-absolute text-center pe-auto"
            aria-hidden="true">&times;</span>
        </div>
      </div>
    </div>
  
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="batchCompleted()">{{ 'shipment.batchYes' | cxTranslate }}</button>
      <button type="button" class="btn btn-outline-secondary" (click)="closeBatchModal()">{{ 'shipment.cancel' | cxTranslate }}</button>
  </div>
</div>


<!-- BL Quantity Pop Up -->
<!-- <div *ngIf="modalToOpen==='bl_quantity'">
    <div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Edit</h4>
		<i class="fa fa-times close-icon" aria-hidden="true" (click)="closeModal()"></i>
	</div>
	<div class="modal-body">
        <h6 class="text-black fw-bold">BL Quantity</h6>
        <form>
            <input id="blQuantity" name="blQuantity" type="text" [formControl]="blQuantity" class="form-control">
        </form>
       
    </div>
    <div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="saveBLQuantity()">Save</button>
        <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Cancel</button>
    </div>
    
</div> -->

<div *ngIf="modalToOpen==='screeningCompleted'">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ 'batches.screeningCompleted' | cxTranslate }}</h4>
    <i class="fa fa-times close-icon" aria-hidden="true" (click)="closeShipmentModal()"></i>
  </div>
  <div class="modal-body">
    <h6 class="text-black ">{{ 'batches.doYouWantToCompleteBatch' | cxTranslate }}</h6><br>
    <!-- <h6 class="text-black ">{{ 'batches.beforeCompleteUploadFile' | cxTranslate }}</h6> -->
    <!--File upload code starts here-->
    <div class="card">
      <div class="mb-3 mt-3 col-md-12 col-sm-12">
        <div>
          <div class="dropdiv" (dragover)="onDragOver($event)" (drop)="onDropSuccess($event)">
            <div class="row d-flex align-items-center">
              <div class="col-md-1">
                <img src="/images/feather_upload-cloud.svg" class="pr-1" alt="icon" width="48"
                  height="48">
              </div>
              <div class="col-md-6 ">
                <div class="small">{{ 'batches.selectAFile' | cxTranslate }}</div>
                <div class="small">{{ 'batches.fileNoMoreThan10mb' | cxTranslate }}</div>
              </div>
              <div class="col-md-5 text-right">
                <span class="d-none">
                  <input accept="application/pdf, image/jpg, image/jpeg, image/png" type="file" #fileInput ng2FileSelect
                    [uploader]="uploader" (onFileSelected)="onFileSelected($event)" />
                </span>
                <div class="btn-group" (click)="fileInput.click()">
                  <label for="files" class="btn btn-outline-primary p-2">{{  'batches.selectFile' | cxTranslate }}</label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div *ngIf="uploader.queue.length != 0">
      <div class="fw-600 mb-2 mt-2"> {{'batches.fileAdded' | cxTranslate}}</div>
    </div>
    <div *ngFor="let item of shipData.screeningDocuments; let i = index;">
      <div (mouseenter)="hoverFileShow1(i)" (mouseleave)="hoverFileHide1(i)" class="small file d-flex">
        <div class="col-md-12">
          <img src="/icons/Vectorpdf.svg" class="pr-1" alt="icon" width="21" height="21"><span>{{
            item?.documentName }}</span><span>.</span>
          <a class="btn btn-sm text-primary shadow-none small" href="{{item.downloadURL}}" target="_blank">
            {{'batches.preview' | cxTranslate}}</a>
          <span class="float-right mt-3 fs-10">{{
            item?.size / 1024 / 1024 | number: '.3'}} MB</span>
        </div>
        <div *ngIf="isHidden" class="float-right row" (click)="deleteFile(i)">
          <span id="hover{{i}}" class="close-icon position-absolute text-center pe-auto"
            aria-hidden="true">&times;</span>
        </div>
      </div>

    </div>
    <div *ngFor="let item of fileArray; let i = index;">
      <div (mouseenter)="hoverFileShow(i)" (mouseleave)="hoverFileHide(i)" class="small file d-flex">
        <div class="col-md-12">
          <img src="/icons/Vectorpdf.svg" class="pr-1" alt="icon" width="21" height="21"><span>{{
            item?.name }}</span><span>.</span><a class="btn btn-sm text-primary small"> {{'batches.preview' | cxTranslate}}</a> <span
            class="float-right mt-3 fs-10">{{
            item?.size / 1024 / 1024 | number: '.3' }} MB</span>
        </div>
        <div *ngIf="selected" class="float-right row" (click)="removeFile(i)">
          <span id="remove{{i}}" class="close-icon position-absolute text-center pe-auto"
            aria-hidden="true">&times;</span>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="uploadErr == true">
      <div class="">
        <div class="filesection_warning mt-2 mb-2">
          <div class="d-flex">
            <div class="d-flex align-items-center w-100 m-2">
              <img src="/icons/Vector.svg" class="p-2">
              <div class="p-2 w-100">
                <p class="upload_file_name">{{'batches.pleaseUploadAFile' | cxTranslate}}</p>
                <p class="upload_file_secondary_text">Before marking this as completed attach a file</p>
              </div>
            </div>
            <div>
              <i class="fa fa-times close-icon p-2" aria-hidden="true" (click)="removeWarning()"></i>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="screeningCompleted()">{{'batches.yes,completed' | cxTranslate}}</button>
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">{{'batches.cancel' | cxTranslate}}</button>
  </div>
</div>

<div *ngIf="modalToOpen==='qualityCompleted'">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ 'batches.qualityInspectionCompleted' | cxTranslate }}</h4>
    <i class="fa fa-times close-icon" aria-hidden="true" (click)="closeShipmentModal()"></i>
  </div>
  <div class="modal-body">
    <h6 class="">{{ 'batches.doYouWantToCompleteQualityInspection' | cxTranslate }}</h6><br>
    
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="qualityCompleted()">{{'batches.yescompleted' | cxTranslate}}</button>
    <button type="button" class="btn btn-outline-secondary" (click)="close('close')">{{'batches.cancel' | cxTranslate}}</button>
  </div>
  </div>



